export default {
  TWO_WEEKS: 'frequency.fortnightly',
  ONE_WEEK: 'frequency.weekly',
  ONE_MONTH: 'frequency.monthly',
};
